// External libraries
import gql from 'graphql-tag';

// Internal modules
import { ADDRESS_METADATA_FRAGMENT } from '../fragments';

export const GRIFFIN_METADATA_QUERY = gql`
  query GriffinMetadataQuery(
    $countryCode: CountryCodes!
    $languageCode: CheckoutContentLanguageCode!
    $shippingCountryCode: CountryCodes!
  ) {
    localeMetadata {
      address(countryCode: $countryCode, languageCode: $languageCode) {
        ...AddressMetadata
      }

      shippingAddress: address(
        countryCode: $shippingCountryCode
        languageCode: $languageCode
      ) {
        ...AddressMetadata
      }

      currencyCode(countryCode: $countryCode)

      date(countryCode: $countryCode, languageCode: $languageCode) {
        displayFormat
        datePattern
      }

      phone(countryCode: $countryCode) {
        masks {
          mobile
        }
        patterns {
          default
        }
      }

      territories(countryCode: $countryCode, languageCode: $languageCode) {
        code
        internationalDialingCode
        name
        region
        suggestedDefaultLanguage
      }
    }
  }
  ${ADDRESS_METADATA_FRAGMENT}
`;
